import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import type { RuntimeFieldSlot } from './runtimeLayoutAdapter'
import { isFieldMandatory } from './validateMandatoryFields'

/**
 * Базовый заголовок поля: имя с раскладки, иначе имя из метаданных типа.
 */
export function runtimeFieldCaptionBase(
  layoutName: string | null | undefined,
  fieldName: string | null | undefined,
): string {
  const fromLayout = layoutName?.trim()
  if (fromLayout) return fromLayout
  return fieldName?.trim() ?? ''
}

/**
 * Label для outlined-контролов: непустой fallback, чтобы Vuetify не схлопывал floating label.
 */
export function runtimePassportFieldLabel(
  layoutName: string | null | undefined,
  fieldName: string | null | undefined,
  mandatory?: unknown,
): string {
  const layout = layoutName?.trim()
  const field = fieldName?.trim()
  const base = layout || field || '\u00a0'
  if (isFieldMandatory(mandatory)) return `${base} *`
  return base
}

/** Caption для карточек / drawer без nbsp-fallback. */
export function runtimeFieldCaptionFromSlot(item: RuntimeFieldSlot): string {
  return runtimeFieldCaptionBase(item.layoutItem.name, item.field.name)
}

/** Label для `InventTypeField` и drawer с учётом обязательности. */
export function runtimePassportFieldLabelFromSlot(item: RuntimeFieldSlot): string {
  return runtimePassportFieldLabel(
    item.layoutItem.name,
    item.field.name,
    item.field.mandatory,
  )
}

/** Label по метаданным поля и опциональному имени с раскладки. */
export function runtimePassportFieldLabelFromMeta(
  field: ObjectInventoryField | null | undefined,
  layoutName?: string | null,
): string {
  return runtimePassportFieldLabel(layoutName, field?.name, field?.mandatory)
}
